
import axios from "axios"

const RestApiService = {
    send: async (endpoint, data, config = null) => {
        // * Si quiero enviar un nuevo dato por config > headers, 
        // * dicha varialbe debe estar autorizada en backend: ResourceServerConfig
        const { data: response } = await axios.post(endpoint, data, config)
        return response
    },
}

export default RestApiService